import { create } from 'zustand';
import { ICommentAPI } from '../components/organism/comment';

interface ICommentState {
  comments: Array<ICommentAPI>;
  allComments: Array<ICommentAPI> | null;
  setComments: (data: any) => void;
  addCommentState: (data: any) => void;
  upvoteCommentState: (data: any) => void;
  showAllComments: () => void;
  totalComments: number;
  totalShowAll: number;
  enableShowAll: boolean;
}

export const useCommentsStore = create<ICommentState>((set, get) => ({
  comments: [],
  totalComments: 0,
  totalShowAll: 0,
  allComments: [],
  enableShowAll: true,
  showAllComments: () => {
    set({
      comments: get().allComments || [],
      enableShowAll: false,
    });
  },
  setComments: (data) =>
    set({
      comments: validateComments(data),
      allComments: validateComments(data, true),
      totalComments: data.length,
      enableShowAll: data.length > 3,
      totalShowAll: data.length - 3,
    }),
  addCommentState: (comment) => {
    const { allComments, comments, totalComments, enableShowAll } = get();

    if (comment.parent) {
      const newAllComments = (allComments || []).map((item) =>
        item.id === comment.parent
          ? { ...item, children: [comment, ...(item.children || [])] }
          : item
      );

      set({
        comments: enableShowAll ? newAllComments.slice(0, 3) : newAllComments,
        allComments: newAllComments,
      });
    } else {
      set({
        comments: [comment, ...(comments || [])],
        allComments: [comment, ...(allComments || [])],
        totalComments: totalComments + 1,
      });
    }
  },
  upvoteCommentState: (data) => {
    function updateComment(comment: ICommentAPI) {
      if (comment.id === data.id) {
        return {
          ...comment,
          likes: data.likes,
          qtdLikes: data.likes.length,
          isLiked: data.like,
        };
      }

      const newChildren: any[] = (comment.children || []).map(updateComment);
      return { ...comment, children: newChildren };
    }

    const allComments = (get().allComments || []).map(updateComment);
    const comments = (get().comments || []).map(updateComment);

    set({ comments, allComments });
  },
}));

const validateComments = (
  comments: Array<ICommentAPI>,
  all: boolean = false
): Array<ICommentAPI> => {
  if (!Array.isArray(comments)) return [];

  return all || comments.length <= 3 ? comments : comments.slice(0, 3);
};
